{
  "settings": {
    "title": "Account & settings",
    "lead": "Your details, language, notifications and data.",
    "signedInAs": "Signed in as {email}",
    "emailVerified": "Email confirmed",
    "emailUnverified": "Email not confirmed yet",
    "guestTitle": "Sign in to do more",
    "guestBody": "With an account you can register for programs, follow offices and your barangay, get notified, and track your reports.",
    "profileTitle": "Your details",
    "profileLead": "These fill in registration forms for you. You always check them before you submit.",
    "moreDetails": "More details for registrations",
    "moreDetailsHint": "Optional. Some programs ask for these.",
    "address": "Address",
    "birthdate": "Birthdate",
    "sex": "Sex",
    "sexChoose": "Choose",
    "sex_female": "Female",
    "sex_male": "Male",
    "sex_prefer_not_to_say": "Prefer not to say",
    "rsbsa": "RSBSA number",
    "rsbsaHint": "Registry System for Basic Sectors in Agriculture. Helps farmers qualify for assistance.",
    "seniorPwdId": "Senior citizen or PWD ID number",
    "school": "School",
    "saveProfile": "Save details",
    "profileSaved": "Your details were saved.",
    "languageTitle": "Language",
    "languageLead": "Office posts appear in the language the office wrote them.",
    "english": "English",
    "filipino": "Filipino",
    "displayTitle": "Display",
    "largeText": "Larger text",
    "highContrast": "High contrast",
    "lowData": "Low-data mode",
    "lowDataHint": "Hides post photos and loads maps only when you tap.",
    "notificationsTitle": "Notifications",
    "notificationsLead": "Alerts on this phone for new posts from offices you follow, registration updates and reminders.",
    "pushOnDevice": "Notifications on this device",
    "pushIsOn": "On",
    "pushIsOff": "Off",
    "pushTurnOn": "Turn on",
    "pushTurnOff": "Turn off",
    "pushTurnedOff": "Notifications are off on this device.",
    "pushNotConfigured": "Notifications aren't available yet. The LGU has not set them up.",
    "manageFollowing": "Choose what you follow",
    "openInbox": "Open notifications",
    "passwordTitle": "Password",
    "currentPassword": "Current password",
    "changePassword": "Change password",
    "passwordUpdated": "Password changed. You were signed out on your other devices.",
    "dataTitle": "Your data",
    "dataLead": "Under the Data Privacy Act (RA 10173) you can get a copy of your data or delete your account at any time.",
    "download": "Download my data",
    "downloadHint": "A file with your account details, registrations, follows and reports.",
    "downloading": "Preparing…",
    "downloaded": "Your data file was downloaded.",
    "deleteTitle": "Delete my account",
    "deleteBody": "This permanently deletes your account and personal details. Your upcoming registrations are cancelled. Emergency and crop damage reports you sent stay with the LGU as official records, but are no longer linked to you.",
    "deleteConfirmLabel": "Enter your password to confirm",
    "deleteConfirm": "Delete permanently",
    "deleting": "Deleting…",
    "deleted": "Your account was deleted.",
    "staffNoDelete": "Staff accounts are removed by your LGU administrator.",
    "workTitle": "LGU work",
    "signedOut": "You are signed out.",
    "smsAlertsTitle": "Urgent alerts by SMS",
    "smsAlertsHint": "Text messages from the LGU during emergencies, sent to your mobile number. Your number is used only for official alerts.",
    "smsAlertsNoMobile": "Add your mobile number in Your details to get urgent alerts by SMS.",
    "smsAlertsOnSaved": "You'll get urgent alerts by SMS.",
    "smsAlertsOffSaved": "You won't get urgent alerts by SMS. They still appear in the app."
  },
  "privacy": {
    "title": "Privacy notice",
    "lead": "How the {lgu} handles your personal information in this app, under the Data Privacy Act of 2012 (RA 10173).",
    "whoTitle": "Who is responsible",
    "whoBody": "The {lgu} is the personal information controller for this app. {app} runs on iLi, a platform the LGU uses to provide its services. Your data is kept in a database for this LGU only.",
    "collectTitle": "What we collect",
    "collect1": "Account details you give us: name, email, mobile number, barangay, and any optional details you add (address, birthdate, sex, RSBSA number, senior or PWD ID number, school).",
    "collect2": "Your registrations for programs and events, and the answers on each registration form.",
    "collect3": "Emergency reports: the location you pin, photos, description, and your name and mobile number.",
    "collect4": "Crop damage reports: farm location, photos, crops and areas affected, and your RSBSA number if you give it.",
    "collect5": "Offices, barangays and categories you follow, and your notification settings, including this device's push notification address.",
    "collect6": "A random ID for this device, used only to prevent abuse such as repeated fake reports.",
    "locationNote": "Your location is saved only on the report you send. The app never tracks where you are.",
    "whyTitle": "Why we use it",
    "why1": "To run the registrations you sign up for and to send you tickets, updates and reminders.",
    "why2": "To respond to emergencies and send help to the right place.",
    "why3": "To validate crop damage and prepare damage reports for assistance from the province and the Department of Agriculture.",
    "why4": "To notify you about offices and barangays you follow.",
    "shareTitle": "Who can see it",
    "shareBody": "Only staff of the office that handles your registration or report can see it. Every staff action is recorded in an audit log. Validated crop damage reports are shared with the provincial agriculture office and the Department of Agriculture. We do not sell your data or use it for advertising.",
    "keepTitle": "How long we keep it",
    "keepBody": "Your account stays until you delete it. Registrations are kept for the LGU's records of each program. Emergency and crop damage reports are official government records and are kept as required by records rules, even after you delete your account; they are no longer linked to you.",
    "rightsTitle": "Your rights",
    "rightsBody": "Under RA 10173 you have the right to be informed, to access your data, to correct it, to object, to have it erased or blocked, to data portability, to damages, and to file a complaint with the National Privacy Commission (privacy.gov.ph).",
    "controlTitle": "Download or delete your data",
    "controlBody": "Go to Account & settings → Your data. You can download a copy of your data or delete your account there at any time.",
    "controlLink": "Open Your data",
    "dpoTitle": "Data Protection Officer",
    "dpoLead": "For questions or requests about your personal data, contact the LGU's Data Protection Officer.",
    "dpoPending": "The contact details of the LGU's Data Protection Officer will be posted here. Until then, visit or call the {lgu}.",
    "dpoName": "Name",
    "dpoEmail": "Email",
    "dpoPhone": "Phone"
  },
  "about": {
    "title": "About",
    "lgu": "{app} brings every office of the {lgu}, {province} into one app: schedules, programs, registration, alerts, and emergency reports.",
    "whatTitle": "What you can do",
    "what1": "See schedules, programs and announcements from every office in one feed.",
    "what2": "Register in a few taps and get a QR ticket.",
    "what3": "Follow offices and your barangay, and get notified.",
    "what4": "Find the nearest evacuation site and hotlines, even offline.",
    "what5": "Report emergencies and damaged crops.",
    "iliTitle": "About iLi",
    "iliTagline": "Your town, in one app.",
    "iliMeaning": "Ili means “town” or “hometown” in Ilocano and the Cordillera languages. The name also reads as information · Local · integrated.",
    "iliBody": "iLi is a civic app platform for Philippine local government units. Each LGU runs its own copy, with its own data kept separate.",
    "linksTitle": "More"
  },
  "more": {
    "hello": "Hi, {name}",
    "guestLead": "Sign in to register, follow offices and get notified."
  },
  "notFound": {
    "lead": "The link may be old, or the page has moved.",
    "hotlines": "See hotlines"
  }
}
